<template>
    <model-select :options="options"
                  v-model="item"
                  class="input"
                  placeholder="Select Client">
    </model-select>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
export default {
    components: {
            ModelSelect
    },
    computed: {
        options() {
            let users = this.$store.getters.getProfitSectionData.users
            let list = []

            users.forEach(function(element) {
                list.push({
                    value: element.id,
                    text: element.name
                })
            })

            return list
        },
        item: {
            get() {
                return this.$store.getters.getProfitSectionData.user_id
            },
            set(value) {
                this.$store.dispatch('setProfitSectionFieldValue', { field: 'user_id', value: value })
            }
        }

    },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Profit/ProfitClientSelect.vue